import { render, staticRenderFns } from "./PickImage.vue?vue&type=template&id=0da43955&"
import script from "./PickImage.vue?vue&type=script&lang=js&"
export * from "./PickImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports